import { Flex, Icon } from '@chakra-ui/react';
import { ToastIcon } from '@/hooks/useShowToast';
import { STATUS_COLORS } from 'ui-library/components/constants';
import { useState } from 'react';
import { X } from '@kula-ai/icons-core';
interface KBannerProps {
  status?: 'success' | 'error' | 'info' | 'warning';
  children: React.ReactNode;
  styleprops?: object;
  childrenprops?: object;
  closeBtn?: boolean;
  onClose?: () => void;
  iconStyles?: object;
  iconWrapperProps?: object;
  closeIconColor?: string;
}

export const KBanner = ({
  status = 'info',
  children,
  styleprops = {},
  childrenprops = {},
  closeBtn = false,
  onClose = () => {},
  iconStyles = {},
  iconWrapperProps = {},
  closeIconColor = 'base-white',
}: KBannerProps) => {
  const { bg } = STATUS_COLORS[status];
  const [showBanner, setBanner] = useState(true);

  const handleClose = () => {
    setBanner(false);
    onClose();
  };

  if (!showBanner) return null;

  return (
    <Flex p="12px" gap="8px" bgColor={bg} borderRadius="6px" {...styleprops}>
      <ToastIcon
        status={status}
        iconStyles={iconStyles}
        iconWrapperProps={iconWrapperProps}
      />
      <Flex w="100%" flexDir="column" {...childrenprops}>
        {children}
      </Flex>
      {closeBtn && (
        <Icon
          as={X}
          color={closeIconColor}
          width="16px"
          height="16px"
          onClick={handleClose}
          cursor="pointer"
        />
      )}
    </Flex>
  );
};
